import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAIChat } from '../AiChatProvider';

export const useChatActions = () => {
  const navigate = useNavigate();
  const { createNewConversation, deleteConversationById } = useAIChat();

  const handleNewChat = useCallback(() => {
    createNewConversation();
    navigate('/chat');
  }, [createNewConversation, navigate]);

  const handleDeleteChat = useCallback(
    (chatId) => {
      if (chatId) {
        deleteConversationById(chatId);
      }
    },
    [deleteConversationById]
  );

  const handleChatClick = useCallback(
    (chatId) => {
      if (chatId) {
        navigate(`/chat/${chatId}`);
      } else {
        handleNewChat();
      }
    },
    [navigate, handleNewChat]
  );

  return {
    handleNewChat,
    handleDeleteChat,
    handleChatClick,
  };
};
